import { Accordion } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';

import { TradePlanDetailType } from '@/cip/_openapi/portfolio-optimizer';
import { booleanCol, dateTimeCol, moneyCol, numberCol, textCol } from '@/cip/widgets/Table/columnHelpers/colDef';

import { DetailsBlock } from './DetailsBlock';
import { GlobalBetaBuyTradePlanDetails, TradeDetailRecord } from './tradeDetailsModel';

export const GlobalBetaBuyDetails = ({
    tradePlanDetails,
}: {
    tradePlanDetails: Partial<Record<TradePlanDetailType, TradeDetailRecord>>;
}) => {
    const details = tradePlanDetails[TradePlanDetailType.DETAILS]?.detailJson;

    return (
        <Accordion allowMultiple>
            {details && (
                <DetailsBlock
                    data={details as GlobalBetaBuyTradePlanDetails[]}
                    columns={detailsColumns}
                    columnSettingsKey="globalBetaBuyDetails"
                    title="Details"
                    initialSort={{ id: 'sId', desc: false }}
                />
            )}
        </Accordion>
    );
};

const detailsColumnHelper = createColumnHelper<GlobalBetaBuyTradePlanDetails>();
const detailsColumns = [
    detailsColumnHelper.accessor('allocationType', textCol({ id: 'allocationType' })),
    detailsColumnHelper.accessor('buy', booleanCol({ id: 'buy' })),
    detailsColumnHelper.accessor('buyRank', numberCol({ id: 'buyRank', format: { fractionDigits: 0 } })),
    detailsColumnHelper.accessor('tradable', booleanCol({ id: 'tradable' })),
    detailsColumnHelper.accessor('notTradableReason', textCol({ id: 'notTradableReason' })),
    detailsColumnHelper.accessor('tradeAmount', moneyCol({ id: 'tradeAmount' })),
    detailsColumnHelper.accessor('price', moneyCol({ id: 'price' })),
    detailsColumnHelper.accessor('tradeQuantity', numberCol({ id: 'tradeQuantity' })),
    detailsColumnHelper.accessor('preference', numberCol({ id: 'preference', format: { fractionDigits: 0 } })),
    detailsColumnHelper.accessor('clientDoNotBuy', booleanCol({ id: 'clientDoNotBuy' })),
    detailsColumnHelper.accessor('washSaleDoNotBuy', booleanCol({ id: 'washSaleDoNotBuy' })),
    detailsColumnHelper.accessor('hasPosition', booleanCol({ id: 'hasPosition' })),
    detailsColumnHelper.accessor('minBuySize', moneyCol({ id: 'minBuySize' })),
    detailsColumnHelper.accessor('isAboveMinBuySize', booleanCol({ id: 'isAboveMinBuySize' })),
    detailsColumnHelper.accessor('targetExposure', moneyCol({ id: 'targetExposure' })),
    detailsColumnHelper.accessor(`minSellConstraint`, moneyCol({ id: 'minSellConstraint' })),
    detailsColumnHelper.accessor(`maxBuyConstraint`, moneyCol({ id: 'maxBuyConstraint' })),
    detailsColumnHelper.accessor('minBuyAmount', moneyCol({ id: 'minBuyAmount' })),
    detailsColumnHelper.accessor('minBuyMultiplier', numberCol({ id: 'minBuyMultiplier' })),
    detailsColumnHelper.accessor('sId', textCol({ id: 'sId' })),
    detailsColumnHelper.accessor('existingPositionMarketValue', moneyCol({ id: 'existingPositionMarketValue' })),
    detailsColumnHelper.accessor('askPrice', moneyCol({ id: 'askPrice' })),
    detailsColumnHelper.accessor('quotePrice', moneyCol({ id: 'quotePrice' })),
    detailsColumnHelper.accessor('priceSource', textCol({ id: 'priceSource' })),
    detailsColumnHelper.accessor('isPriceMissing', booleanCol({ id: 'isPriceMissing' })),
    detailsColumnHelper.accessor('priceTimestamp', dateTimeCol({ id: 'priceTimestamp' })),
];
